// extracted by mini-css-extract-plugin
module.exports = {"CheckoutSummary":"CheckoutSummary__CheckoutSummary__3SGBL"};